<template>
    <div class="EoPVerificationReport">
        <div v-if="isLoading" class="content-container">
            <div class="loading">
                <span class="loader"></span>
            </div>
        </div>
        <div v-else class="content-container">
            <NewEoPVerificationReport 
            v-if="showNewFormatReport" 
            :displayedEoPVerificationsList=displayedEoPVerificationsList
            :key=newEoPKeyValue
            >
                <div class="top-content form-container">
                    <PeriodSelector v-model=periodSelection showTitle @update:model-value=updatePeriodSelection />
                    <div class="flex-col-centered selection">
                        <label> <h3 class="header">Type Selection:</h3></label>
                        <select v-model=displayTypeSelection @update:model-value=updateTypeSelection>
                            <option
                            v-for="reportType in displayedEoPVerificationsList"
                            :value="reportType.EoPType"
                            >
                                {{ reportType.EoPName }}
                            </option>
                        </select>
                    </div>
                </div>
            </NewEoPVerificationReport>
            <div v-else class="top-content">
                <div class="top-container">
                    <div class="eop-v-info">
                        <tbody>
                            <tr>
                                <td style="font-weight: bold;">Summary:</td>
                                <td style="font-weight: bold;">{{ displayType }}</td>
                                <td>
                    
                                </td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">EoP Status:</td>
                                <td>
                                    <div
                                        v-if="
                                        currentEoPVerificationReport?.EoPStatus.toUpperCase().startsWith(
                                                'ERROR'
                                            )
                                        "
                                        class="failure"
                                    >
                                        {{ currentEoPVerificationReport?.EoPStatus }} - DEVIATIONS DETECTED
                                    </div>
                                    <div
                                        v-else-if="currentEoPVerificationReport?.EoPStatus.toUpperCase() == 'SUCCESS'"
                                        class="highlight-green-bold"
                                    >
                                        {{ currentEoPVerificationReport?.EoPStatus }}
                                    </div>
                                    <div v-else>{{ currentEoPVerificationReport?.EoPStatus }}</div>
                                </td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Journaling Status:</td>
                                <td>
                                    <div
                                        v-if="currentEoPVerificationReport?.JournalingStatus.toUpperCase() == 'INCOMPLETE'"
                                        class="failure"
                                    >
                                        {{ currentEoPVerificationReport?.JournalingStatus }} 
                                    </div>
                                    <div
                                        v-else-if="currentEoPVerificationReport?.JournalingStatus.toUpperCase() == 'COMPLETE'"
                                        class="highlight-green-bold"
                                    >
                                        {{ currentEoPVerificationReport?.JournalingStatus }}
                                    </div>
                                    <div v-else>{{ currentEoPVerificationReport?.JournalingStatus }}</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Processed:</td>
                                <td>{{ currentEoPVerificationReport?.ProcessedDateTime }}</td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Total Amount:</td>
                                <td>{{ formatAmount(currentEoPVerificationReport?.TotalAmount!) }}</td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Amount Diff:</td>
                                <td>{{ formatAmount(currentEoPVerificationReport?.DeviationAmount!) }}</td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Number of Errors:</td>
                                <td>{{ currentEoPVerificationReport?.NumberOfErrorItems }}</td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">View Invoice:</td>
                                <td>                           
                                    <div v-if="hasInvoice">
                                        <div v-if="currentEoPVerificationReport!.InvoicesInspected!.length <= 5">
                                            <li class="file-list" v-for="file in currentEoPVerificationReport?.InvoicesInspected">
                                                    <button
                                                    @click="viewFullPagePDFInvoice(file,journalType!)"
                                                    :disabled="invoicePdfButtonStatus"
                                                    :title="
                                                        invoicePdfButtonStatus
                                                            ? ''
                                                            : 'View report pdf (opens file in new tab)'
                                                    "
                                                    class="fake-link"
                                                    >
                                                        {{ file }}
                                                    </button>
                                            </li>
                                        </div>
                                        <div v-if="currentEoPVerificationReport!.InvoicesInspected!.length > 5">
                                            <div class="invoice-scroll-box">
                                                <li class="file-list" v-for="file in currentEoPVerificationReport?.InvoicesInspected">
                                                    <button
                                                    @click="viewFullPagePDFInvoice(file,journalType!)"
                                                    :disabled="invoicePdfButtonStatus"
                                                    :title="
                                                        invoicePdfButtonStatus
                                                            ? ''
                                                            : 'View report pdf (opens file in new tab)'
                                                    "
                                                    class="fake-link"
                                                    >
                                                        {{ file }}
                                                    </button>
                                                </li>
                                            </div>
                                        </div>                                
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style="font-weight: bold;">Detailed Report:</td>
                                <td>
                                    <button
                                        @click="viewFullPagePDFReport(currentEoPVerificationReport?.ReportName!,'EndOfPeriodVerification')"
                                        :disabled="detailedReportPdfButtonStatus"
                                        :title="
                                            invoicePdfButtonStatus
                                                ? ''
                                                : 'View report pdf (opens file in new tab)'
                                        "
                                        class="fake-link"
                                    >
                                        {{ currentEoPVerificationReport?.ReportName }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </div>
                    <div>
                        <div class="top-content form-container">
                            <PeriodSelector v-model=periodSelection showTitle @update:model-value=updatePeriodSelection />
                            <div class="flex-col-centered selection">
                                <label> <h3 class="header">Type Selection:</h3></label>
                                <select v-model=displayTypeSelection @update:model-value=updateTypeSelection>
                                    <option
                                    v-for="reportType in displayedEoPVerificationsList"
                                    :value="reportType.EoPType"
                                    >
                                        {{ reportType.EoPName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="new-report-button-div">
                        <button
                            @click="CreateNewReport()"
                            :disabled="buttonStatus || gettingEoPVerificationReportError || DenyFunctionLevelAccess(FunctionAccessLevels.CreateEoPVReport)"
                            :title="DenyFunctionLevelAccess(FunctionAccessLevels.CreateEoPVReport) ? 'Create New Report (Access Denied)' : 'Create New Report'"
                            class="new-report-button"
                        >
                            Create New Report
                        </button>
                        <button
                            @click="showMultiplePeriodReportPopUp = !showMultiplePeriodReportPopUp"
                            :disabled="buttonStatus || gettingEoPVerificationReportError || DenyFunctionLevelAccess(FunctionAccessLevels.CreateEoPVReport)"
                            :title="DenyFunctionLevelAccess(FunctionAccessLevels.CreateEoPVReport) ? 'Create New Report (Access Denied)' : 'Create New Report'"
                            class="new-report-button"
                        >
                            Create New Multiple Period Report
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="!showNewFormatReport" class="table-container">
                <h2>Previous Reports</h2>
                <Table
                    :Rows=pastEoPVerificationReports
                    :Cols=cols
                    :Labels=labels
                    :DefaultSortCols=defaultSortCols
                    :DefaultSortOrders=defaultSortOrders
                    v-model:Page=page
                    :HasError=infoError
                >
                    <template #ProcessedDateTime="props">
                            {{ props.value.ProcessedDateTime }}
                    </template>
                    <template #TotalAmount="props">
                        <div>
                            {{ formatAmount(props.value.TotalAmount) }}
                        </div>
                    </template>
                    <template #DeviationAmount="props">
                        <div>
                            {{ formatAmount(props.value.DeviationAmount) }}
                        </div>
                    </template>
                    <template #ReportName="props">
                        <button
                            @click="viewFullPagePDFReport(props.value.ReportName ?? undefined,'EndOfPeriodVerification')"
                            :disabled="detailedReportPdfButtonStatuses[props.value.ReportName ?? '']"
                            :title="detailedReportPdfButtonStatuses[props.value.ReportName ?? ''] ? 
                                    '' : 
                                    'View report pdf (opens file in new tab)'
                            "
                            class="fake-link"
                        >
                            {{ props.value.ReportName }}
                        </button>
                    </template>
                </Table>
            </div>
        </div>
        <MultiplePeriodEoPVerificationReportPopUp
            v-model=showMultiplePeriodReportPopUp
            :period="period"
            @confirm="CreateNewMultiplePeriodReport"
        /> 
    </div> 
</template>

<script setup lang="ts">
import { ref, onMounted, inject, computed } from "vue";
import router from "@/router";
import {
    cols,
    labels,
    EoPVerificationReportServices,
    defaultSortCols,
    defaultSortOrders
} from "@/services/helpers/EoPVerificationReportHelper";
import { FunctionAccessLevels, DenyFunctionLevelAccess } from "@/config/AuthConfig";
// Data
import EoPVerificationReport from "@/models/EoPVerifications/EoPVerificationReport";
// Table
import Table from "@/components/TablePersistentChecking.vue";
// Misc
import { useRoute } from "vue-router";
import log from "loglevel";
import { authService } from "@/auth/authSingleton";
import { apiLoggerKey, globalReloadKey } from "@/types/ServiceKeys";
import { EoPJournalingTypes } from "@/models/EoPVerifications/EoPJournalingTypes";
import MultiplePeriodEoPVerificationReportPopUp from "@/components/MultiplePeriodEoPVerificationReportPopUp.vue"
import NewEoPVerificationReport from "./NewEoPVerificationReport.vue";
import PeriodSelector from "@/components/PeriodSelector.vue";
import DatePeriod from "@/types/DatePeriod";
import { eoPVerificationHeader } from "@/services/network";
import { IEoPItem, IEoPVerifications } from "@/Interfaces/EoPVerifications/IEoPVerifications";
import { parseData } from "@/services/helpers/EoPVerificationsHelper";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const reload = inject(globalReloadKey);
const JournalTypesWithNewReportUi: string[] = [EoPJournalingTypes.SERVICE_INVOICE, EoPJournalingTypes.CHURN, EoPJournalingTypes.RECHARGE_INVOICE, EoPJournalingTypes.REMARKETING, EoPJournalingTypes.CAR_PURCHASE, EoPJournalingTypes.RVGF, EoPJournalingTypes.CUSTOMER_INVOICE];

const fileName = "EoPVerification.vue";
const Logger = inject(apiLoggerKey);

const page = ref(1);

const hasInvoice = ref(false);
const hasMultipleInvoices = ref(false);
const showNewFormatReport = ref(false);
const showMultiplePeriodReportPopUp = ref(false)
const EoPVerifications = ref<IEoPVerifications>();
const displayedEoPVerificationsList = ref<IEoPItem[]>();
log.debug("End of Period Verification Report");

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
    log.trace("onMounted() EoPVerificationReport");
    document.title = `EoP Verification (${journalType}) - UV`;
    let selectedJournalReportType = route.params.id;
    await GetEoPVerificationReportOptions(market ?? 'GB', period.value)
    if(JournalTypesWithNewReportUi.includes(selectedJournalReportType as string)){
        isLoading.value = false;
        showNewFormatReport.value = true;
    }else{
        //@ts-expect-error
        await GetEoPVerificationReport(journalType.value,market,period.value,company);//.then(() => {});
    }
});

// Get EoP Verification Report Data from API
async function GetEoPVerificationReport(journalType: string, market: string, period: string, company: string) {
    const name = GetEoPVerificationReport.name;
    const Class = fileName + "/" + name;

    const urlParams: string = url + `/${journalType}?market=${market}&period=${period}&company=${company}`;
    
    let Message = `Getting EoP Verification report (${urlParams})`;
    log.trace(`${name}()\n${Message}`);
    try {
        isLoading.value = true;
        hasInvoice.value = false;
        const data = await EoPVRServices.processEoPVerificationData(urlParams);
        eoPVerificationReports.value = data.map(x=>new EoPVerificationReport(x));
        currentEoPVerificationReport.value = eoPVerificationReports.value[0];
        pastEoPVerificationReports.value = eoPVerificationReports.value.slice(1);
        if (!!currentEoPVerificationReport.value) {
            if (!!currentEoPVerificationReport.value.InvoicesInspected){
            hasInvoice.value = true;
            hasMultipleInvoices.value = (currentEoPVerificationReport.value.InvoicesInspected!.length > 1);
            }
        }
        Logger?.LogInformation(Message, Class);
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting EoP Verification Report"})
        gettingEoPVerificationReportError.value = true;
        infoError.value = true;
        Message = `(Error) ${Message}: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}

async function GetEoPVerificationReportOptions(market: string, period: string) {
    const name = GetEoPVerificationReportOptions.name;
    const Class = fileName + "/" + name;
    
    const periodValue = periodSelection.value;
    var Message = `Getting EoPVerifications (market: ${market}, period: ${period})`;
    log.debug("Loading EoPVerification Reports from API");
    isLoading.value = true;
    if (!periodValue.isValid()) console.trace('API periodSelection should not be invalid');
    try {
        const data = (await eoPVerificationHeader.get({market: market.toString(), period: periodValue})).data;
        EoPVerifications.value = data;
        displayedEoPVerificationsList.value = parseData(data);
        displayedEoPVerificationsList.value?.sort((a,b) => {return a.Category.localeCompare(b.Category)})
        Logger?.LogInformation(Message, Class);
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting EoP Verification Report Options"})
        infoError.value = true;
        Message = `(Error) ${Message}, error: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}

// ERROR
const gettingEoPVerificationReportError = ref(false);
const infoError = ref(false);

// TABLE
const isLoading = ref(true);
const url: string = process.env.VUE_APP_EOP_VERIFICATIONS_URL_PARAMS!; 
const eoPVerificationReports = ref<EoPVerificationReport[]>();
const currentEoPVerificationReport = ref<EoPVerificationReport>();
const pastEoPVerificationReports = ref<EoPVerificationReport[]>();

// MISC
const EoPVRServices = new EoPVerificationReportServices();
const buttonStatus = ref(false);

// Send POST request to create new EoP Verification Report
async function CreateNewReport() {
    const name = CreateNewReport.name;
    const Class = fileName + "/" + name;

    log.trace(`${name}()\njournalType: ${journalType}`);
    log.debug("Removing EoPVerifications from sessionStorage");
    sessionStorage.removeItem("EoPVerifications");

    // Disable button until 201 status response
    buttonStatus.value = true;
    isLoading.value = true;

    // Get MARKET and PERIOD from EoP Verifications
    EoPVRServices.LogCreateNewReport(
        market,
        company,
        period.value,
        journalType.value ? journalType.value : "",
    );
    // Send POST request
    try {
        const status = await EoPVRServices.CreateNewEoPReport({
            UserName: authService.getEmailAddress(),
            Market: market ? market : "",
            Company: company,
            StartPeriodMonth: period.value,
            JournalType: journalType.value ? journalType.value : "",
        });
        if (status === 201) {
            log.debug(`CreateNewReport()\nstatus: ${status}`);

            // refresh page
            reload?.();

            // enable button
            buttonStatus.value = false;
            isLoading.value = false;
        }
    } catch (error ){
        useNotifierWithErrFormatter().error({error, errorType: "Creating new EoP verification report"})
        // enable button
        buttonStatus.value = false;
        const Message = `(Error) Creating new EoP Verifications report: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        isLoading.value = false;
    }
}
async function CreateNewMultiplePeriodReport(startPeriod : DatePeriod, endPeriod : DatePeriod) {
    const name = CreateNewReport.name;
    const Class = fileName + "/" + name;

    log.trace(`${name}()\njournalType: ${journalType}`);
    log.debug("Removing EoPVerifications from sessionStorage");
    sessionStorage.removeItem("EoPVerifications");

    // Disable button until 201 status response
    buttonStatus.value = true;
    isLoading.value = true;

    // Get MARKET and PERIOD from EoP Verifications
    EoPVRServices.LogCreateNewMultiplePeriodReport(
        market,
        company,
        startPeriod.toString(),
        endPeriod.toString(),
        journalType.value ? journalType.value :  "",
    );
    // Send POST request
    try {
        const status = await EoPVRServices.CreateNewEoPReport({
            UserName: authService.getEmailAddress(),
            Market: market ? market.toString() : "",
            Company: company,
            StartPeriodMonth: startPeriod.toString(),
            EndPeriodMonth: endPeriod.toString(),
            JournalType: journalType.value!,
        });
        if (status === 201) {
            log.debug(`CreateNewMultiplePeriodReport()\nstatus: ${status}`);
            useNotifierWithErrFormatter().success({msg: "New Multiple Period EoP Verification Report has been created"})
            // refresh page
            reload?.();
        }
    } catch (error ){
        useNotifierWithErrFormatter().error({error, errorType: "Creating new EoP verification report"})
        const Message = `(Error) Creating new multiple period EoP Verifications report: ${error}`;
        log.error(Message);
        Logger?.LogError(Message, Class);
    } finally {
        buttonStatus.value = false;
        isLoading.value = false;
    }
}
const invoicePdfButtonStatus = ref(false);
const detailedReportPdfButtonStatus = ref(false);
const detailedReportPdfButtonStatuses = ref<Record<string,boolean>>({});

// View full page pdf in new tab 
function viewFullPagePDFInvoice(fileID: string | undefined, fileType: string | undefined,) {
    log.trace("viewFullPagePDFInvoice()");
    log.debug(`"viewFullPagePDFInvoice()": ${fileID}`);

    const rResolved = router.resolve({
        name: "EoP Verification (PDF)",
        params: {
            id: fileID,
        },
        query: {
            type: fileType,
            endpoint: process.env.VUE_APP_JOURNALED_INVOICES_DOWNLOAD_URL_PARAMS,
            method: "post"
        },
    });
    const url = rResolved.href;
    // Open in new tab
    window.open(url, "_blank");
}
function viewFullPagePDFReport(fileID: string | undefined, fileType: string | undefined,) {
    log.trace("viewFullPagePDFReport()");
    log.debug(`"viewFullPagePDFReport()": ${fileID}`);

    const rResolved = router.resolve({
        name: "EoP Verification (PDF)",
        params: {
            id: fileID,
        },
        query: {
            type: fileType,
            endpoint: process.env.VUE_APP_DETAILED_REPORT_PDF_EOP_VERIFICATIONS_URL_PARAMS,
            method: "get"
        },
    });
    const url = rResolved.href;
    // Open in new tab
    window.open(url, "_blank");
}

// ROUTE
const route = useRoute();
const journalType = computed( () => {return route.path.split("/").pop()});
const market = route.query.market?.toString();
const company = "Volvo";
const period = computed( () => {return route.query.period?.toString() ?? ""});
const displayType = computed( () => {return route.query.type?.toString() ?? ""});
const periodSelection =  ref(new DatePeriod(period ? new Date(period.value) : new Date().addMonths(-1)));
const displayTypeSelection = ref(route.query.type?.toString());
const newEoPKeyValue = ref(0);

function formatAmount(amount: string) {

    const number = parseFloat(amount);

    if (isNaN(number)) {
        return 0.00.toFixed(2);
    }

    const formattedNumber = number.toFixed(2);

    return formattedNumber;
}
async function updatePeriodSelection() {
     log.trace("ViewEoPVerificationReport()\nId:", displayType.value);
    const r = {
        name: "EoP Verification Report",
        params: {
            id: journalType.value,
        },
        query: {
            market: market,
            period: periodSelection.value.toString(),
            type: displayType.value
        },
    };
    await router.replace(r);
    document.title = `EoP Verification (${displayType.value}) - UV`;
    let selectedJournalReportType = displayType.value;
    if(JournalTypesWithNewReportUi.includes(selectedJournalReportType as string)){
        isLoading.value = false;
        newEoPKeyValue.value++;
        showNewFormatReport.value = true;
    }else{
        GetEoPVerificationReport(displayType.value ,market ? market : "",period.value,company);
    }
}
async function updateTypeSelection() {
    log.trace("ViewEoPVerificationReport()\nId:", displayTypeSelection.value);
    const r = {
        name: "EoP Verification Report",
        params: {
            id: displayTypeSelection.value ,
        },
        query: {
            market: market,
            period: period.value,
            type: displayTypeSelection.value
        },
    };
    await router.replace(r);
    document.title = `EoP Verification (${displayTypeSelection.value}) - UV`;
    let selectedJournalReportType = displayTypeSelection.value;
    if(JournalTypesWithNewReportUi.includes(selectedJournalReportType as string)){
        isLoading.value = false;
        newEoPKeyValue.value++
        showNewFormatReport.value = true;
    }else{
        showNewFormatReport.value = false;
        GetEoPVerificationReport(displayTypeSelection.value ? displayTypeSelection.value : "", market ? market : "", period.value, company);
    }
}

</script>

<style scoped lang="scss">
@import "@/assets/styles/layout.scss";
.eop-v {
    padding: 2%;
}
.eop-v-info {
    padding: 2%;
}
.eop-v-new-report {
    padding-left: 2%;
}
.eop-v-reports {
    padding-bottom: 2%;
}
.eop-v-reports h2 {
    display: flex;
    justify-content: center;
    align-items: center;
}
.new-report-button {
    border-radius: var(--buttons-border-radius);
    background-color: var(--primary-color-lighter);
    padding: 10px;
    color: blue;
    font-size: larger;
    font-weight: bold;
    border: none;
}
.new-report-button:hover {
    cursor: pointer;
    background-color: var(--primary-color);
    color: white;
}
.new-report-button:disabled {
    border-width: 1px;
    color: var(--primary-color-dark);
    background-color: var(--light-grey);
    cursor: not-allowed;
}
.new-report-button:visited {
    color: inherit;
}
.file-list {
    list-style-type: none;
}
.new-report-button-div {
    display: flex;
    flex-direction: column;
    gap: 2em;
    padding-top:5%;
    padding-right:4%;
}
.invoice-scroll-box {
    height: 95px;
    width: 130px;
    overflow-y: scroll;
}
.top-container {
    display: flex;
    align-items: start;
    justify-content: space-between;
}
.contents {
    display:contents;
}
.form-container {
    display:grid;
    grid-template-columns: auto;
    gap: 20px;
    justify-content: space-evenly;
    justify-items: center;
    align-items: center;
    >*{
        min-width: 10rem;
        width: 100%;
        >*{
            width: 100%;
        }
    }
    :deep(select) {
        width: 100%;
    }
}
</style>